// Restore only known workbench entries; a saved preference never grants access.
export function resolveWorkbenchOperation(path, schoolId, showNotifications, platformManager) {
  if (!schoolId || typeof path !== 'string') return null;
  const entries = [
    ['staff', '教师管理'], ['devices', '设备管理'],
    [`/broadcast?schoolId=${schoolId}&action=send`, '发送广播 / 文件'],
    ['/classes', '班级管理'], ['/students', '学生资料'], ['/classes/schedule', '课程表'],
    ['/classes/duty', '值日表'], ['/classes/seat', '座位表'], ['/students/grades', '成绩管理'],
    ['/broadcast', '广播管理'], ['/classes/todos', '班级待办'], ['/classes/parent-binding', '家长绑定'],
    ['/smart-attendance?tab=manual', '考勤管理'], ['/smart-attendance?tab=video', '视频看班'],
    ['/students/points-new', '积分管理'],
    ...(showNotifications ? [
      [`/school-operations?schoolId=${schoolId}&action=notice`, '发布通知'],
      [`/school-operations?schoolId=${schoolId}&action=task`, '安排任务'],
      ['/school-operations', '学校通知与任务']
    ] : []),
    ...(platformManager ? [[`/schools/${schoolId}/edit`, '编辑学校资料']] : [])
  ];
  const match = entries.find(([entry]) => entry === path);
  if (match) return { path, title: match[1] };
  // A grade selected in the device table can also be pinned, within this school.
  if (path.startsWith('/grade-management?')) {
    const params = new URLSearchParams(path.split('?')[1]);
    if (params.get('schoolId') === String(schoolId) && params.get('tab') === 'managers'
      && [...params.keys()].every(key => ['schoolId', 'grade', 'tab'].includes(key))
      && [...params.keys()].length === new Set(params.keys()).size) return { path, title: '年级负责人' };
  }
  return null;
}

export function workbenchPreferenceKey(userId, schoolId) {
  return userId && schoolId ? `school-workbench:pinned:v1:${encodeURIComponent(userId)}:${encodeURIComponent(schoolId)}` : null;
}
